import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import initialProject from 'helpers/projects/initialProject'
import { updateProjectSelector } from 'selectors'
import compressProject from 'helpers/projects/compressProject'
import { MERGE_PERMALINK_PROJECT } from 'actions/projectActionTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import createDocumentSaga from 'sagas/createDocumentSaga'

function * mergePermalinkProject() {
  try {
    const { currentEntity, cameras, mapLocation, zoom, ui, title,
      createdAt, mapType, floorPlans, markups, entities } = yield select(updateProjectSelector)

    const compressedPermalinkProject =
      compressProject({ updatedAt: Date.now(), cameras, mapLocation, zoom,
        ui, title, createdAt, mapType, floorPlans, markups, currentEntity, entities })

    const document = { ...initialProject(), ...compressedPermalinkProject, ...{ title: title || 'Permalink Project' } }
    yield call(createDocumentSaga, document)
    window.location.assign(window.location.origin)
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: MERGE_PERMALINK_PROJECT }))
  }
}

export function * watchMergePermalinkProject() {
  yield * takeEvery(MERGE_PERMALINK_PROJECT, mergePermalinkProject)
}



// WEBPACK FOOTER //
// ./src/sagas/mergePermalinkProjectSaga.js